import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array'

import Vue from 'vue';
import App from './App';
import router from './router';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import Vuelidate from 'vuelidate'
import store from "./store";

import {i18n} from './shared/locales/i18n'
import Filters from "./shared/services/filters"
import ConstPlugin from "./shared/constants/index";
import Snotify from 'vue-snotify';
import Multiselect from 'vue-multiselect';
import AppSvgIcon from "./components/common/utils/AppSvgIcon";
import LangFlag from "./components/common/utils/lang_flag/LangFlag";
import { VueEditor } from "vue2-editor";
import {
  hasRole,
  isWorker,
  isSuperAdmin,
  isLocalAdmin,
  isApprover,
  isAdmin,
  hasPermission, hasAnyOfPermissions, isFreelancer
} from "./shared/services/permission";
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import ToggleButton from 'vue-js-toggle-button';
import {handleApiErrors, resolveErrorMessage} from "./shared/services/apiErrorHandler";
import {setTimesheetsInStore} from "./shared/services/timesheets";

if (window.location.origin.includes(process.env.VUE_APP_HAYS_URL_PREFIX)) {
  import ("./assets/scss/default/style.scss");
} else {
  import ("./assets/scss/freelancer/style.scss");
}

Vue.use(ToggleButton);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.use(ConstPlugin);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.component('lang-flag', LangFlag);

Vue.component('multiselect', Multiselect);
Vue.component('AppSvgIcon', AppSvgIcon)

Vue.use(Snotify, {
  toast: {
    timeout: 5000,
    titleMaxLength: 40
  }
});
Vue.mixin({
  methods: {
    hasRole(roles) {
      return hasRole(roles);
    },
    hasPermission(permission) {
      return hasPermission(permission);
    },
    hasAnyOfPermissions(permissions) {
      return hasAnyOfPermissions(permissions);
    },
    isSuperAdmin(role = store.getters["auth/role"]) {
      return isSuperAdmin(role)
    },
    isLocalAdmin(role = store.getters["auth/role"]) {
      return isLocalAdmin(role)
    },
    isApprover(role = store.getters["auth/role"]) {
      return isApprover(role)
    },
    isWorker(role = store.getters["auth/role"]) {
      return isWorker(role)
    },
    isAdmin(role = store.getters["auth/role"]) {
      return isAdmin(role);
    },
    isFreelancer(role = store.getters["auth/role"]) {
      return isFreelancer(role);
    },
    resolveErrorMessage(error) {
      return resolveErrorMessage(error);
    },
    handleApiError(error) {
      handleApiErrors(error);
    },
    setTimesheetsInStore(user, timesheets) {
      setTimesheetsInStore(user, timesheets);
    }
  }
});
Vue.component('calendar', Calendar);
Vue.component('date-picker', DatePicker);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
  template: '<App/>',
  i18n,
  beforeCreate() {
    Vue.$snotify = this.$snotify;
    Vue.$store = this.$store;
  },

  components: {
    App,
    Filters,
    Calendar,
    DatePicker
  }
})
